import { BASE_URL } from 'config/urls';

import { post, requestSdk } from 'utils/sdk';

export const cancelSubscription = async (subscriptionStripeId) =>
  await requestSdk(() =>
    post(`${BASE_URL}/v1/subscriptions/${subscriptionStripeId}/cancel/`)
  );
